module.exports = __webpack_public_path__ + "fonts/Inter-300-vietnamese19.9df1755.woff2";